'use client';

import React, { FC, useEffect, useState } from 'react';

import { TypeFooter, TypeSubFooter } from '@/core/generated-types';

import { useIsDesktop } from '@/hooks/useIsDesktop';
import { useRestrictedCartMode } from '@/hooks/useRestrictedCartMode';

import { usePathname } from '@/navigation';

import SubFooter from '../SubFooter/SubFooter';

import FooterSections from './FooterSections';

import { isSubflowPathname } from './utils';

interface FooterProps {
  footer: TypeFooter;
  footerLegal: TypeSubFooter;
}

const Footer: FC<FooterProps> = ({ footer, footerLegal }) => {
  const pathname = usePathname();

  const showSimpleNav = !useIsDesktop();

  const [isSimpleNavType, setIsSimpleNavType] = useState(false);

  const isRestrictedCart = useRestrictedCartMode();

  const shouldHideFooter = pathname?.endsWith('/cart') ?? false;

  useEffect(() => {
    setIsSimpleNavType(Boolean(showSimpleNav && isSubflowPathname(pathname)));
  }, [pathname, showSimpleNav]);

  // Don't render footer on regular cart page or in restricted cart mode
  if (shouldHideFooter || isRestrictedCart) return null;

  const { footerSections } = footer?.fields || {};

  return (
    <footer data-testid="le-footer">
      {footerSections && !isSimpleNavType && (
        <FooterSections footerSections={footerSections} />
      )}

      {footerLegal?.fields && (
        <SubFooter fields={footerLegal.fields} dataTestId="footer-legal" />
      )}
    </footer>
  );
};

export default React.memo(Footer);
